import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=41190d3b&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=41190d3b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41190d3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41190d3b')) {
      api.createRecord('41190d3b', component.options)
    } else {
      api.reload('41190d3b', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=41190d3b&scoped=true&", function () {
      api.rerender('41190d3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wvzD47c4x4si/JS/comp/Paginate.vue"
export default component.exports